import { ActiveLookup, LookupKeys, Messages, Patterns, Website, WebsiteKeys } from '@ag-common-lib/public-api';
import { Component, effect, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { WebsiteFormService } from './website-form.service';
import { validateUrlWithOrWithoutProtocol } from 'ag-common-svc/lib/utils/validation';

@Component({
  selector: 'ag-shr-website-form',
  templateUrl: './website-form.component.html',
  styleUrls: ['./website-form.component.scss'],
})
export class WebsiteFormComponent {
  @HostBinding('class') protected className = 'website-form';

  @Input() validationGroup: string;
  @Input() websitesTypesLookup: ActiveLookup[] = [];

  @Input()
  set website(value: Website) {
    this.formData = this.websiteFormService.getFormData(value);
  }

  @Output() hasFormChanges = new EventEmitter<boolean>(false);

  protected formData: Partial<Website>;
  protected readonly WebsiteKeys = WebsiteKeys;
  protected readonly LookupKeys = LookupKeys;
  protected readonly BaseModelKeys = BaseModelKeys;
  protected readonly Messages = Messages;

  constructor(private websiteFormService: WebsiteFormService) {
    effect(() => {
      const hasFormChanges = this.websiteFormService.hasFormChangesSig();
      this.hasFormChanges.emit(hasFormChanges);
    });
  }

  onCancelEdit = this.websiteFormService.onCancelEdit;

  validateUrlWithoutProtocol = e =>
    validateUrlWithOrWithoutProtocol(e?.value, Patterns.URL_PATTERN_WITH_OR_WITHOUT_ONLY_ONE_PROTOCOL);
}
